import { ShopifyAppNames } from "@redotech/redo-model/sales-channels";
import {
  array,
  boolean,
  object,
  string,
  enum as zEnum,
  null as zNull,
  type infer as zInfer,
} from "zod/v4";

export const setCloudXIntegration = {
  name: "setCloudXIntegration" as const,
  input: object({
    clientSecret: string(),
    warehouseAsPlainString: string(),
    testMode: boolean(),
    autoProcessReturns: boolean().optional().default(true),
    upcType: zEnum(["sku", "barcode"]).optional().default("sku"),
    excludedAppNames: array(zEnum(ShopifyAppNames)).optional().default([]),
  }),
  output: zNull(),
};

export type SetCloudXIntegrationInput = zInfer<
  typeof setCloudXIntegration.input
>;
